import { AppBase, baseFromDoc, FirestoreBaseDoc, makeDocConverter } from '../base/firestore-model-base'

/**
 * ProjectCounter モデル（レガシー）
 *
 * 以前はプロジェクト番号の連番管理に使用していた。
 * 現在の案件番号は付番ルール S-YYYYMMDD-XX に従い、
 * school の案件登録（project-add）時に登録日とランダム2文字で生成され、以降変更されない。
 *
 * 本カウンターは school_accounts/{schoolId}/project_counters/{year} に保存される。
 * 既存データとの互換のため型・参照は残している。
 *
 * @example
 * // 2026年のカウンター（参照用）
 * {
 *   last_sequence: 5,
 *   updated_at: Timestamp
 * }
 */

/**
 * シンプル版（Doc/App + converter）
 */

/** Firestoreに保存される形（Timestampのまま） */
export type ProjectCounterDoc = FirestoreBaseDoc & {
  /** 最後に使用された連番（次は last_sequence + 1） */
  last_sequence: number
  /** この年度に作成されたプロジェクトの path リスト */
  projects?: string[]
}

/** アプリで使う形（Date に変換） */
export type ProjectCounterEntity = AppBase & {
  /** 年（ドキュメントIDとして使用）例: "2026" */
  year: string
  last_sequence: number
  projects: string[]
}

export const projectCounterDocConverter = makeDocConverter<ProjectCounterDoc>()

function refToPath(v: unknown): string | null {
  return typeof v === 'string' ? v : (v as { path?: string; id?: string } | null)?.path ?? (v as { id?: string } | null)?.id ?? null
}

export function toProjectCounterEntity(id: string, doc: ProjectCounterDoc, path: string): ProjectCounterEntity {
  const raw = (doc as { projects?: unknown }).projects
  const projects = Array.isArray(raw)
    ? raw.map((r) => (typeof r === 'string' ? r : refToPath(r) ?? '')).filter(Boolean)
    : []
  return {
    ...baseFromDoc(id, doc, path),
    year: id,
    last_sequence: doc.last_sequence,
    projects,
  }
}
